export default defineNuxtRouteMiddleware(() => {
	const routeUrl = useRouteUrl()
	const userStore = useUserStore()
	if (
		userStore.token &&
		userStore.user?.status === "enable" &&
		["admin", "blogger", "support", "developer"].includes(userStore.user?.type)
	) {
		return navigateTo(routeUrl.AdminDashboardUrl())
	}
})
